import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=b58b0772"
import script from "./Well.vue?vue&type=script&lang=js"
export * from "./Well.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports